/* eslint-disable @khan/frontend/require-stories -- TODO */
import {MathInputI18nContextProvider} from "@khanacademy/math-input";
// eslint-disable-next-line no-restricted-imports -- TODO
import * as Perseus from "@khanacademy/perseus";
import {RequestInfo} from "@khan/shared-core";

import {mathInputStrings} from "../math-input-strings-lingui.tsx";
import {perseusStrings} from "../perseus-strings-lingui.tsx";

/**
 * A simple wrapper which ensures that the I18nProviders are set up correctly
 * for Perseus and MathInput.
 */
export const PerseusI18nProviderWrapper = (props: {
    children: React.ReactNode;
}) => {
    return (
        <MathInputI18nContextProvider
            locale={RequestInfo.kaLocale}
            strings={mathInputStrings()}
        >
            <Perseus.PerseusI18nContextProvider
                locale={RequestInfo.kaLocale}
                strings={perseusStrings()}
            >
                {props.children}
            </Perseus.PerseusI18nContextProvider>
        </MathInputI18nContextProvider>
    );
};
